import loadable from '@wix/yoshi-flow-editor/loadable';

export const FilesPages = loadable(
  () => import(/* webpackChunkName: "FilesPage" */ './FilesPage'),
  {
    resolveComponent: (component) => component.FilesPage,
  },
);
